import { IconsProps } from '@/types/shared'
import React from 'react'

const NavigateBeforeIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59L11.1249 12L15.7049 7.41Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default NavigateBeforeIcons
